import { render, staticRenderFns } from "./cdmaRadcheck.vue?vue&type=template&id=4521d13a&scoped=true"
import script from "./cdmaRadcheck.vue?vue&type=script&lang=js"
export * from "./cdmaRadcheck.vue?vue&type=script&lang=js"
import style0 from "./cdmaRadcheck.vue?vue&type=style&index=0&id=4521d13a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4521d13a",
  null
  
)

export default component.exports